import { Directive, ViewContainerRef, TemplateRef, Input } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthorizationByStatusModel } from '../models/authorization-model';
import { AppConstants } from '../app.constants';

@Directive({
  selector: '[removeIfUnauthorizedResult]'
})
export class RemoveIfUnauthorizedResultDirective {
  private hasView: boolean = false;

  constructor(private container: ViewContainerRef,
    private template: TemplateRef<any>,
    private authService: AuthService) { }

  @Input() set removeIfUnauthorizedResult(authModel: AuthorizationByStatusModel) {
    if (authModel == null || !authModel.role.length || !authModel.roleUserType.length) {
      this.hasView = false;
      return;
    }

    let hasRole = !!authModel.role.length && this.authService.hasRole(authModel.role);
    let hasUserTypeRole = this.authService.hasUserTypeRole(authModel.roleUserType);
    let isCreator = this.authService.isCreator(authModel.creatorId);
    let isSupervisor = this.authService.isSupervisor(authModel.supervisorId);
    let isApprover = this.authService.isSupervisor(authModel.alternateApproverId);
    let isFDLeadership = authModel.isFieldDivisionLeadership;
    let isHqAdminOrpowerUser = this.authService.isHQAdminOrPowerUser();

    if (authModel.status && authModel.entityState == AppConstants.Result_FormMode_Edit) {
      switch (authModel.status) {
        case AppConstants.Result_Status_Draft:
          if ((((isCreator || isSupervisor || isApprover) && hasUserTypeRole) || hasRole) && this.hasView) {
            this.hasView = true;
          } else if ((((isCreator || isSupervisor || isApprover) && hasUserTypeRole) || hasRole) && !this.hasView) {
            this.container.createEmbeddedView(this.template);
            this.hasView = true;
          } else if ((((isCreator || isSupervisor || isApprover) && !!hasUserTypeRole) || !hasRole) && !this.hasView) {
            this.container.clear()
            this.hasView = false;
          } else if ((!isCreator && !isSupervisor && !isApprover && !hasRole) && this.hasView) {
            this.container.clear();
            this.hasView = false;
          } else {
            this.container.clear();
            this.hasView = false;
          }
          break;
        case AppConstants.Result_Status_Pending1stLineApproval:
          if ((((isSupervisor || isApprover) && !!hasUserTypeRole) || hasRole) && this.hasView) {
            this.hasView = true;
          } else if ((((isSupervisor || isApprover) && !!hasUserTypeRole) || hasRole) && !this.hasView) {
            this.container.createEmbeddedView(this.template);
            this.hasView = true;
          } else if ((((isSupervisor || isApprover) && !!hasUserTypeRole) || !hasRole) && !this.hasView) {
            this.container.clear()
            this.hasView = false;
          } else if ((!isSupervisor && !isApprover && !hasRole) && this.hasView) {
            this.container.clear();
            this.hasView = false;
          } else {
            this.container.clear();
            this.hasView = false;
          }
          break;
        case AppConstants.Result_Status_1stLineRejected:
          if ((((isCreator || isSupervisor || isApprover || isHqAdminOrpowerUser) && hasUserTypeRole) || hasRole) && this.hasView) {
            this.hasView = true;
          } else if ((((isCreator || isSupervisor || isApprover || isHqAdminOrpowerUser) && hasUserTypeRole) || hasRole) && !this.hasView) {
            this.container.createEmbeddedView(this.template);
            this.hasView = true;
          } else if ((((isCreator || isSupervisor || isApprover) && !!hasUserTypeRole) && !!hasRole) && !this.hasView) {
            this.container.clear();
            this.hasView = false;
          } else if ((!isCreator && !isSupervisor && !isApprover && !hasRole) && this.hasView) {
            this.container.clear();
            this.hasView = false;
          } else {
            this.container.clear();
            this.hasView = false;
          }
          break;
        case AppConstants.Result_Status_Pending2ndLineApproval:
          if (((isFDLeadership && !!hasUserTypeRole) || hasRole) && this.hasView) {
            this.hasView = true;
          } else if (((isFDLeadership && !!hasUserTypeRole) || hasRole) && !this.hasView) {
            this.container.createEmbeddedView(this.template);
            this.hasView = true;
          } else if ((!isFDLeadership && !hasRole) && this.hasView) {
            this.container.clear();
            this.hasView = false;
          } else {
            this.container.clear();
            this.hasView = false;
          }
          break;
        case AppConstants.Result_Status_2ndLineRejected:
          if ((((isSupervisor || isApprover || isCreator || isFDLeadership) && !!hasUserTypeRole) || hasRole) && this.hasView) {
            this.hasView = true;
          } else if ((((isSupervisor || isApprover || isCreator || isFDLeadership) && !!hasUserTypeRole) || hasRole) && !this.hasView) {
            this.container.createEmbeddedView(this.template);
            this.hasView = true;
          } else if ((((isSupervisor || isApprover || isCreator || isFDLeadership) && !!hasUserTypeRole) || !hasRole) && !this.hasView) {
            this.container.clear()
            this.hasView = false;
          } else if ((!isSupervisor && !isApprover && !isCreator && !isFDLeadership && !hasRole) && this.hasView) {
            this.container.clear();
            this.hasView = false;
          } else {
            this.container.clear();
            this.hasView = false;
          }
          break;
        case AppConstants.Result_Status_2ndLineApproved:
          if ((((isSupervisor || isApprover || isCreator || isFDLeadership) && !!hasUserTypeRole) || hasRole) && this.hasView) {
            this.hasView = true;
          } else if ((((isSupervisor || isApprover || isCreator || isFDLeadership) && !!hasUserTypeRole) || hasRole) && !this.hasView) {
            this.container.createEmbeddedView(this.template);
            this.hasView = true;
          } else if ((((isSupervisor || isApprover || isCreator || isFDLeadership) && !!hasUserTypeRole) || !hasRole) && !this.hasView) {
            this.container.clear()
            this.hasView = false;
          } else if ((!isSupervisor && !isApprover && !isCreator && !isFDLeadership && !hasRole) && this.hasView) {
            this.container.clear();
            this.hasView = false;
          } else {
            this.container.clear();
            this.hasView = false;
          }
          break;
      }
    } else if (typeof (authModel.canCreate) !== 'undefined') {
      if (authModel.entityState === AppConstants.Result_FormMode_Add && (hasRole || hasUserTypeRole) && authModel.canCreate && this.hasView) {
        this.hasView = true;
      } else if (authModel.entityState === AppConstants.Result_FormMode_Add && (hasRole || hasUserTypeRole) && authModel.canCreate && !this.hasView) {
        this.container.createEmbeddedView(this.template);
        this.hasView = true;
      } else if (authModel.entityState === AppConstants.Result_FormMode_Add && (hasRole || hasUserTypeRole) && !authModel.canCreate && this.hasView) {
        this.container.clear();
        this.hasView = false;
      } else if (authModel.entityState === AppConstants.Result_FormMode_Add && !(hasRole || hasUserTypeRole) && !authModel.canCreate && this.hasView) {
        this.container.clear();
        this.hasView = false;
      }
    } else {
      if (authModel.entityState === AppConstants.Result_FormMode_Add && (hasRole || hasUserTypeRole) && this.hasView) {
        this.hasView = true;
      } else if (authModel.entityState === AppConstants.Result_FormMode_Add && (hasRole || hasUserTypeRole) && !this.hasView) {
        this.container.createEmbeddedView(this.template);
        this.hasView = true;
      } else if (authModel.entityState === AppConstants.Result_FormMode_Add && !(hasRole || hasUserTypeRole) && this.hasView) {
        this.container.clear();
        this.hasView = false;
      } else {
        this.container.clear();
        this.hasView = false;
      }
    }
  }
}
